var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSettingRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20.001,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    overflow: "hidden",
    viewBox: "0 0 21 20.001",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("path", {
    x: -67,
    y: 125,
    width: 21,
    height: 20,
    d: "M-67.001 125.001h21v20.001h-21v-20.001z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1"
  }, /*#__PURE__*/React.createElement("path", {
    x: -66,
    y: 125,
    width: 19,
    height: 19,
    d: "M-65.999 125.001h19v19h-19v-19z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2"
  }, /*#__PURE__*/React.createElement("path", {
    x: -66,
    y: 125,
    width: 19,
    height: 19,
    d: "M-65.999 125.001h19v19h-19v-19z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)",
    transform: "translate(67 -125)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m13.193 15.605 0.308 -1.4 -1.003 -0.221a3.563 3.563 0 0 0 -0.24 -1.342l0.868 -0.555 -0.772 -1.208 -0.87 0.555a3.565 3.565 0 0 0 -1.117 -0.78l0.221 -1.004 -1.4 -0.308 -0.221 1.003a3.552 3.552 0 0 0 -1.341 0.24l-0.555 -0.865 -1.208 0.772 0.555 0.868a3.582 3.582 0 0 0 -0.782 1.117l-1.004 -0.222 -0.308 1.4 1.004 0.221a3.559 3.559 0 0 0 0.24 1.342l-0.87 0.555 0.772 1.208 0.868 -0.555a3.566 3.566 0 0 0 1.117 0.78l-0.219 1.004 1.4 0.308 0.221 -1.004a3.559 3.559 0 0 0 1.342 -0.24l0.553 0.868 1.208 -0.772 -0.555 -0.87a3.57 3.57 0 0 0 0.78 -1.117Z",
    stroke: "#ff0026",
    strokeWidth: 0.6204079999999998,
    strokeMiterlimit: 10,
    fill: "none",
    transform: "matrix(1 0 0 1.01886 -66.523 124.217)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.063 13.93a2.151 2.151 0 1 1 -4.3 0 2.151 2.151 0 0 1 4.3 0Z",
    stroke: "#ff0026",
    strokeWidth: 0.6204079999999998,
    strokeMiterlimit: 10,
    fill: "none",
    transform: "matrix(1 0 0 1.01886 -66.523 124.217)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h20.267v20.267H0Z",
    stroke: "#ff0026",
    strokeWidth: 0.413605,
    fill: "none",
    transform: "matrix(1 0 0 1.01886 -66.523 124.217)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.328 6.37a1.838 1.838 0 1 1 -3.675 0 1.838 1.838 0 0 1 3.675 0Z",
    stroke: "#ff0026",
    strokeWidth: 0.6204079999999998,
    strokeMiterlimit: 10,
    fill: "none",
    transform: "matrix(1 0 0 1.01886 -66.523 124.217)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.121 7.067v-1.393l-0.537 -0.128a3.178 3.178 0 0 0 -0.32 -0.789l0.285 -0.46 -0.984 -0.985 -0.453 0.28a3.164 3.164 0 0 0 -0.803 -0.336l-0.123 -0.514h-1.395l-0.121 0.514a3.16 3.16 0 0 0 -0.803 0.336l-0.453 -0.28 -0.985 0.985 0.285 0.46a3.187 3.187 0 0 0 -0.32 0.789l-0.537 0.128v1.395l0.551 0.13c0.074 0.268 0.182 0.523 0.322 0.761l-0.299 0.488 0.985 0.984 0.495 -0.306a3.104 3.104 0 0 0 0.747 0.306l0.135 0.572h1.395l0.135 -0.572a3.16 3.16 0 0 0 0.747 -0.306l0.497 0.306 0.985 -0.985 -0.303 -0.487a3.201 3.201 0 0 0 0.322 -0.761Z",
    stroke: "#ff0026",
    strokeWidth: 0.6204079999999998,
    strokeMiterlimit: 10,
    fill: "none",
    transform: "matrix(1 0 0 1.01886 -66.523 124.217)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.303 5.316a0.964 0.964 0 1 1 -1.929 0 0.964 0.964 0 0 1 1.93 0Z",
    stroke: "#ff0026",
    strokeWidth: 0.6204079999999998,
    strokeMiterlimit: 10,
    fill: "none",
    transform: "matrix(1 0 0 1.01886 -66.523 124.217)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.751 5.316a2.428 2.428 0 0 0 -0.091 -0.653l0.717 -0.413 -0.593 -1.031 -0.717 0.413a2.408 2.408 0 0 0 -1.132 -0.653V2.152h-1.19v0.828A2.41 2.41 0 0 0 3.614 3.633l-0.719 -0.415L2.301 4.247l0.717 0.415a2.356 2.356 0 0 0 0 1.305l-0.717 0.413 0.593 1.031 0.717 -0.411a2.411 2.411 0 0 0 1.132 0.653v0.828h1.188v-0.828A2.417 2.417 0 0 0 7.065 7l0.717 0.415 0.593 -1.031 -0.717 -0.413a2.436 2.436 0 0 0 0.091 -0.654Z",
    stroke: "#ff0026",
    strokeWidth: 0.6204079999999998,
    strokeMiterlimit: 10,
    fill: "none",
    transform: "matrix(1 0 0 1.01886 -66.523 124.217)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingRed);
export default __webpack_public_path__ + "static/media/SettingRed.21a1d2414b211fe8d3732b57318dd788.svg";
export { ForwardRef as ReactComponent };